import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Container,
  Segment,
  Grid,
  Header,
  Button,
  Table,
  Modal,
  Form,
  Dropdown,
  Input,
  Tab
} from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import moment from 'moment';
import * as actionCreators from './actions';
import {
  getPaymentHistory,
  getNextPayment,
  getPaymentDetails
} from '../payment/actions';
import PaymentDetails from '../payment/PaymentDetails';
const getPaymentType = type => {
  switch (type) {
    case 0:
      return 'wallet:walletHeaderText';
    case 1:
      return 'wallet:creditCardText';
    default:
      return 'wallet:walletHeaderText';
  }
};

function combineHistory(paymentHistory, walletHistory) {
  let history = [];
  history = history.concat(
    paymentHistory.map(payment => ({
      date: moment(payment.date),
      type: 'wallet:withdrawText',
      amount: payment.amount / 100
    }))
  );
  history = history.concat(
    walletHistory
      .filter(payment => payment.status === 'completed')
      .map(payment => ({
        date: moment(payment.date),
        type: 'wallet:depositText',
        amount: payment.amount / 100
      }))
  );

  return history;
}

const options = [
  { key: 'PLN', text: 'PLN', value: 'PLN' },
  { key: 'EUR', text: 'EUR', value: 'EUR' },
  { key: 'USD', text: 'USD', value: 'USD' }
];

class Wallet extends Component {
  state = {
    visible: false,
    firstname: this.props.user.firstname,
    surname: this.props.user.surname,
    email: this.props.user.email,
    amount: 0,
    currency: this.props.t('wallet:currency'),
    description: 'Doladowanie portfela',
    userId: this.props.user.userId,
    activePayment: undefined,
    modalPaymentVisible: false
  };

  componentDidMount() {
    this.props.getWallet();
    this.props.getPaymentHistory();
    this.props.getWalletHistory();
    this.props.getNextPayment();
  }
  changeField = (field, value) => this.setState({ [field]: value });

  openModalWithPayment = payment => {
    this.props.getPaymentDetails(payment.paymentId);
    this.setState({
      activePayment: payment,
      modalPaymentVisible: true
    });
  };
  closeModal = () => {
    this.setState({
      modalPaymentVisible: false
    });
  };
  toggleModal = () =>
    this.setState(prevState => ({ visible: !prevState.visible }));

  submit = (proxy, data) => {
    const { visible, ...rest } = this.state;
    if (!rest.amount || rest.amount <= 0) {
      return;
    }
    if (!rest.firstname || !rest.surname) {
      return;
    }

    this.props.deposit(rest);
    this.toggleModal();
  };

  render() {
    let wallet = this.props.wallet;
    const { t, nextPayment } = this.props;
    const dummyWallet = {
      currency: t('wallet:currency'),
      balance: 0,
      paymentType: 0,
      rate: 1.0
    };
    if (!wallet) {
      wallet = dummyWallet;
    }

    const panes = [
      {
        menuItem: t('wallet:walletHistoryText'),
        render: () => (
          <Tab.Pane attached="bottom">
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{t('wallet:dateText')}</Table.HeaderCell>
                  <Table.HeaderCell>{t('wallet:typeText')}</Table.HeaderCell>
                  <Table.HeaderCell>{t('wallet:amountText')}</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {combineHistory(
                  this.props.walletHistory,
                  this.props.paymentHistory
                )
                  .sort(function(left, right) {
                    return moment.utc(right.date).diff(moment.utc(left.date));
                  })
                  .map(history => (
                    <Table.Row>
                      <Table.Cell>
                        {moment(history.date).format('DD-MM-YYYY')}
                      </Table.Cell>
                      <Table.Cell collapsing>{t(history.type)}</Table.Cell>
                      <Table.Cell collapsing>{`${history.amount} ${
                        wallet.currency
                      }`}</Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>
          </Tab.Pane>
        )
      },
      {
        menuItem: t('wallet:paymentHistoryText'),
        render: () => (
          <Tab.Pane attached="bottom">
            <PaymentDetails
              onOpen={this.openModalWithPayment}
              onClose={this.closeModal}
              payment={this.props.paymentDetails}
              active={this.state.modalPaymentVisible}
            />

            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{t('wallet:dateText')}</Table.HeaderCell>
                  <Table.HeaderCell>{t('wallet:amountText')}</Table.HeaderCell>
                  <Table.HeaderCell>Status</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {this.props.paymentHistory.map(payment => (
                  <Table.Row key={payment.id}>
                    <Table.Cell>
                      {moment(payment.date).format('DD-MM-YYYY')}
                    </Table.Cell>

                    <Table.Cell collapsing>{`${payment.amount / 100} ${
                      wallet.currency
                    }`}</Table.Cell>
                    <Table.Cell collapsing>{payment.status}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Tab.Pane>
        )
      }
    ];

    return (
      <Container>
        <Modal open={this.state.visible}>
          <Modal.Header>Charge wallet</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <Form onSubmit={this.submit}>
                <Form.Field>
                  <label>Amount</label>
                  <Input
                    label={
                      <Dropdown
                        defaultValue={wallet.currency}
                        options={options}
                        disabled={!!wallet.id}
                        value={this.state.currency}
                        onChange={(proxy, data) =>
                          this.changeField('currency', data.value)
                        }
                      />
                    }
                    labelPosition="right"
                    type="number"
                    value={this.state.amount}
                    onChange={(proxy, input) =>
                      this.changeField('amount', input.value)
                    }
                  />
                </Form.Field>

                <Form.Group widths="equal">
                  <Form.Input
                    label="Firstname"
                    value={this.state.firstname}
                    onChange={(proxy, input) =>
                      this.changeField('firstname', input.value)
                    }
                  />
                  <Form.Input
                    label="Surname"
                    value={this.state.surname}
                    onChange={(proxy, input) =>
                      this.changeField('surname', input.value)
                    }
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Button type="submit" color="blue">
                    Deposit
                  </Form.Button>
                  <Form.Button onClick={this.toggleModal}>Cancel</Form.Button>
                </Form.Group>
              </Form>
            </Modal.Description>
          </Modal.Content>
        </Modal>
        <Header as="h1">{t('wallet:walletHeaderText')}</Header>
        <Segment>
          <Grid columns="equal" centered>
            <Grid.Column verticalAlign="middle" textAlign="left">
              <Header>{`${t('wallet:balanceText')}: ${parseInt(wallet.balance) /
                100} ${wallet.currency}`}</Header>
            </Grid.Column>
            <Grid.Column textAlign="right">
              <Button onClick={this.toggleModal}>
                {t('wallet:chargeButtonText')}
              </Button>
            </Grid.Column>
          </Grid>
        </Segment>
        <Grid columns="equal">
          <Grid.Column>
            <Segment>
              <Grid columns="equal">
                <Grid.Column verticalAlign="middle" textAlign="left">
                  <Header as="h3">
                    {`${t('wallet:paymentTypeText')}: ${t(
                      getPaymentType(wallet.paymentType)
                    )}`}
                  </Header>
                </Grid.Column>
                <Grid.Column textAlign="right">
                  <Button>{t('wallet:changeButtonText')}</Button>
                </Grid.Column>
              </Grid>
            </Segment>
            <Segment>
              <Header as="h3">{t('wallet:nextPaymentText')}</Header>
              <p>
                <strong>{`${t('wallet:estimatedPriceText')}:`}</strong>{' '}
                {`${Math.round(wallet.rate * nextPayment.rooms * 100) / 100} ${
                  wallet.currency
                }`}
              </p>
              <p>
                <strong>{`${t('wallet:dateText')}:`}</strong>{' '}
                {moment(nextPayment.date).format('DD-MM-YYYY')}
              </p>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Tab panes={panes} />
          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    phase: state.wallet.phase,
    wallet: state.wallet.data,
    rooms: state.rooms.data,
    user: state.account.user,
    walletHistory: state.wallet.history,
    paymentHistory: state.payment.history,
    nextPayment: state.payment.next,
    paymentDetails: state.payment.details
  };
};
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    { ...actionCreators, getPaymentHistory, getNextPayment, getPaymentDetails },
    dispatch
  )
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate('translations')(Wallet));



// WEBPACK FOOTER //
// ./src/wallet/index.js